<script>
import NavBar from '@components/nav-bar.vue'
import SignOut from '@components/sign-out.vue'

export default {
  components: { NavBar, SignOut },
  methods: {
    onCollapse(collapsed, type) {},
    onBreakpoint(broken) {},
  },
}
</script>

<template>
  <a-layout>
    <a-layout-sider
      breakpoint="lg"
      collapsed-width="0"
      :collapsible="true"
      @collapse="onCollapse"
      @breakpoint="onBreakpoint"
    >
      <div class="logo" />
      <NavBar v-if="$auth.isAuthenticated && $auth.user.profile" />
      <div v-else :class="$style.logo">
        <router-link to="/" exact>
          <img
            src="https://vanished-fe.s3.us-east-2.amazonaws.com/mantle-w-2.png"
            alt="logo"
          />
        </router-link>
      </div>
      <div class="sign-out--container">
        <SignOut />
      </div>
    </a-layout-sider>
    <a-layout id="a-layout--container">
      <a-layout-content :style="{ margin: '0' }">
        <slot />
      </a-layout-content>
      <a-layout-footer
        v-if="$auth.isAuthenticated && $auth.user.profile"
        style="color: white; text-align: center; background: #141414"
      >
        Umbra Labs © 2023
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<style lang="scss" module>
@import '@design';

.logo {
  width: 100%;
  padding: $size-grid-padding;
  margin-bottom: $size-grid-padding;
  text-align: center;
  border-width: 3px;
  border-bottom: 3px solid white;
  border-image-source: linear-gradient(to left, #fafafa, #8c8c8c);
  border-image-slice: 1;

  img {
    width: 95%;
  }
}

.container {
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  margin: 0 auto;
}
</style>
